import { useState, useEffect } from 'react'

interface TimeLeft {
  hours: number
  minutes: number
  seconds: number
}

export function useCountdown() {
  // Initialize with target time (5 minutes from first load)
  const [targetTime] = useState(() => {
    const now = new Date().getTime()
    return now + 5 * 60 * 1000 // 5 minutes in milliseconds
  })

  const calculateTimeLeft = (): TimeLeft => {
    const now = new Date().getTime()
    const difference = targetTime - now

    if (difference > 0) {
      return {
        hours: 0,
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      }
    }

    // When timer reaches 0, reset to 5 minutes
    return { hours: 0, minutes: 5, seconds: 0 }
  }

  const [timeLeft, setTimeLeft] = useState<TimeLeft>(calculateTimeLeft())

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft())
    }, 1000)

    return () => clearInterval(timer)
  }, [targetTime])

  return timeLeft
}
